export default __webpack_public_path__ + "static/media/16-DeezerDark.4240d109.png";